var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-item-checkbox"},[_c('div',{staticClass:"d-flex"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }